import axios from "axios";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import baseurl from "./Baseurl";
import { useCart } from "./CartContext";
import { ToastContainer, toast } from "react-toastify";

const Shearchbar = () => {
  let Navigate = useNavigate();
  const { cartRefresh, triggerCartRefresh } = useCart();

  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");

  let [showprofile, setshowprofile] = useState([]);
  let [show_f_cartlist, setshow_f_cartlist] = useState([]);
  let [show_cart_list, setshow_cart_list] = useState([]);

  let [search_result, setsearch_result] = useState([]);
  let [storevalue, setstorevalue] = useState("");
  let [selectedSuggestion, setSelectedSuggestion] = useState("");

  let [searchStatus, setSearchStatus] = useState("idle");
  let [showDropdown, setShowDropdown] = useState(false);
  let [isSearching, setIsSearching] = useState(false);

  const searchTimeoutRef = useRef(null);

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const payload = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          payload
        );
        if (res?.data?.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.log("wsda", error);
      }
    };
    fetchProfile();
  }, []);

  let singout = () => {
    try {
      let item = { _id: _id };
      axios
        .post(`${process.env.REACT_APP_API}website/logout`, item)
        .then((res) => {
          if (res.data.result) {
            localStorage.removeItem("ssstoken");
            secureLocalStorage.removeItem("n_id");
            secureLocalStorage.removeItem("n_token");
            secureLocalStorage.removeItem("n_mobile_no");
            secureLocalStorage.removeItem("n_otp");
            Navigate(`/`);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) { }
  };

  useEffect(() => {
    const fetchFavouriteList = async () => {
      try {
        const items = { user_id: _id };
        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_favourite_product_list`,
          items,
          { headers: { token } }
        );
        if (res.data?.result) {
          setshow_f_cartlist(res.data.data);
        } else {
          setshow_f_cartlist([]);
        }
      } catch (error) {
        setshow_f_cartlist([]);
        console.log("Error fetching favourite product list", error);
      }
    };
    if (_id && token) fetchFavouriteList();
  }, [_id, token, cartRefresh]);

  const fetchProduct = async () => {
    try {
      let items = { user_id: _id };
      const res = await axios.post(
        `${process.env.REACT_APP_API}website/cart_details`,
        items,
        { headers: { token } }
      );
      if (res?.data?.result) {
        setshow_cart_list(res.data.data);
      } else {
        setshow_cart_list([]);
      }
    } catch (error) {
      setshow_cart_list([]);
      console.log(error);
    }
  };

  useEffect(() => {
    fetchProduct();
  }, [cartRefresh]);

  let Single_products = (singleproducts) => {
    secureLocalStorage.setItem("n_singleproducts", singleproducts);
    Navigate(`/single_products`);
  };

  let delete_card = (productsid, quantity) => {
    try {
      let items = {
        user_id: _id,
        product_id: productsid,
      };
      axios
        .post(
          `${process.env.REACT_APP_API}website/delete_cart_product`,
          items,
          { headers: { token: token } }
        )
        .then((res) => {
          if (res.data.result) {
            toast.success(res.data.msg);
            fetchProduct();
            triggerCartRefresh();
          }
        })
        .catch((error) => {
          triggerCartRefresh();
          console.log(error);
        });
    } catch (error) {
      console.log(error);
      triggerCartRefresh();
    }
  };

  let [freshfruit, setfreshfruit] = useState([]);

  useEffect(() => {
    const fetchFreshFruit = async () => {
      try {
        const res = await axios.get(`${baseurl[0].apiurl}category_list`);
        if (res.data.result) {
          setfreshfruit(res.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };
    fetchFreshFruit();
  }, []);

  let categoryid = (sub_category_list_id) => {
    secureLocalStorage.setItem("n_sub_category_list_id", sub_category_list_id);
    Navigate(`/shopscategory`);
  };

  // REAL-TIME SEARCH HANDLER
  let searchHandal = (e) => {
    const value = e.target.value;
    setstorevalue(value);

    // Clear previous timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // If empty input
    if (!value.trim()) {
      setsearch_result([]);
      setSearchStatus("idle");
      setShowDropdown(false);
      setIsSearching(false);
      setSelectedSuggestion("");
      return;
    }

    // If less than 2 characters
    if (value.trim().length < 2) {
      setSearchStatus("typing");
      setShowDropdown(true);
      setsearch_result([]);
      setIsSearching(false);
      return;
    }

    // Valid input - start debounce timer
    setSearchStatus("typing");
    setShowDropdown(true);
    setIsSearching(true);

    searchTimeoutRef.current = setTimeout(() => {
      performSearch(value);
    }, 600);
  };

  // PERFORM SEARCH FUNCTION - FIXED FOR MULTIPLE SEARCHES
  const performSearch = async (searchTerm) => {
    console.log("🔍 Searching for:", searchTerm);
    setSearchStatus("searching");

    try {
      let data = { product_name: searchTerm };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/search_product_name`,
        data
      );

      console.log("✅ API Response:", res.data);

      const apiResult = res?.data?.result;
      const apiData = res?.data?.data;

      if (apiResult === "true" || apiResult === true) {
        if (apiData && Array.isArray(apiData) && apiData.length > 0) {
          console.log("🎯 Found products:", apiData.length);
          setsearch_result(apiData);
          setSearchStatus("success");
        } else {
          console.log("📭 No products found");
          setsearch_result([]);
          setSearchStatus("no_results");
        }
      } else {
        console.log("❌ API returned false");
        setsearch_result([]);
        setSearchStatus("no_results");
      }
    } catch (error) {
      console.error("🔥 Search error:", error);
      setsearch_result([]);
      setSearchStatus("no_results");
    } finally {
      setIsSearching(false);
    }
  };

  // FIXED: SUGGESTION CLICK - WORKING FOR MULTIPLE TIMES
  const getValue = (productName) => {
    // console.log("👉 Clicked suggestion:", productName);
    
    // Set input value
    setstorevalue(productName);
    setSelectedSuggestion(productName);
    
    // Save to localStorage
    // localStorage.setItem("searchname", productName);
    Navigate("/SearchProducts", {
  state: { searchname: productName }
});

    // IMPORTANT: Don't clear search results immediately
    // Keep the dropdown open to show results
    setShowDropdown(true);
    
    // Perform search for the selected suggestion
    performSearch(productName);
    
    // Clear any pending timeout
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }
  };

  // FIXED: SEARCH BUTTON CLICK - WORKING FOR MULTIPLE TIMES
  const btngetValue = (e) => {
    e.preventDefault();
    if (storevalue.trim()) {
      // console.log("🔍 Search button clicked for:", storevalue);
      // localStorage.setItem("searchname", storevalue);
      
      // Don't navigate immediately, show results first
      setShowDropdown(true);
      performSearch(storevalue);
    }
  };

  // NAVIGATE TO SEARCH PAGE AFTER SHOWING RESULTS
  const navigateToSearchPage = () => {
    if (storevalue.trim()) {
      // console.log("🚀 Navigating to search page with:", storevalue);
      // localStorage.setItem("searchname", storevalue);
      Navigate(`/SearchProducts`);
      Navigate("/SearchProducts", {
  state: { searchname: storevalue }
});

    }
  };

  // Handle input focus
  const handleInputFocus = () => {
    if (!storevalue.trim()) {
      setShowDropdown(true);
    } else if (storevalue.trim().length >= 2) {
      setShowDropdown(true);
    }
  };

  // Handle click outside dropdown
  useEffect(() => {
    const handleClickOutside = (e) => {
      if (!e.target.closest('.search-form') && !e.target.closest('.dropdown-menu')) {
        setShowDropdown(false);
      }
    };
    document.addEventListener('click', handleClickOutside);
    return () => {
      document.removeEventListener('click', handleClickOutside);
    };
  }, []);

  // Cleanup timeout on unmount
  useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  return (
    <div>
      <ToastContainer position="top-center" />
      
      <div id="active-sticky2" className="header-space bg-white">
        <div className="container">
          <div className="row align-items-center">
            <div className="col-6 col-sm-4 col-lg-7 col-xl-8">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <div className="d-flex align-items-center vertical-menu">
                    <div className="dropdown">
                      <div
                        className="dropdown-menu"
                        style={{ paddingRight: "60px" }}
                      >
                        {freshfruit?.map((items, index) => (
                          <span
                            key={index}
                            className="dropdown-item"
                            onClick={() => categoryid(items._id)}
                            style={{ fontSize: "17px", cursor: "pointer" }}
                          >
                            {items.category_name}
                          </span>
                        ))}
                      </div>
                    </div>

                    <a href="/" style={{ zIndex: "0" }} className="logo">
                      <img
                        style={{ zIndex: "0" }}
                        src="/assets/images/logo/Vaishnavi.png"
                        alt="image_not_found"
                        width={150}
                      />
                    </a>
                  </div>
                </div>
                <div
                  className="flex-grow-1 d-none d-lg-block"
                  style={{ color: "white" }}
                >
                  <form className="search-form position-relative" onSubmit={btngetValue}>
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter your search key ... "
                        value={storevalue}
                        onChange={searchHandal}
                        onFocus={handleInputFocus}
                      />
                      <div className="input-group-text">
                        <button
                          className="search-btn btn-success"
                          type="submit"
                          onClick={btngetValue}
                        >
                          <i className="ion-ios-search-strong"></i>
                        </button>
                      </div>

                      {/* FIXED DROPDOWN - WORKS MULTIPLE TIMES */}
                      {showDropdown && (
                        <div
                          className="dropdown-menu show"
                          style={{
                            width: "100%",
                            maxHeight: "300px",
                            overflowY: "auto",
                            zIndex: 9999
                          }}
                        >
                          {/* Empty input */}
                          {!storevalue.trim() && (
                            <div className="dropdown-item text-center py-3 text-muted">
                              <i className="las la-search fs-4 mb-2 d-block"></i>
                              <div>Search for products</div>
                            </div>
                          )}

                          {/* Less than 2 chars */}
                          {storevalue.trim().length === 1 && (
                            <div className="dropdown-item text-center py-2 text-muted">
                              Type at least 2 characters...
                            </div>
                          )}

                          {/* Searching state */}
                          {isSearching && storevalue.trim().length >= 2 && (
                            <div className="dropdown-item text-center py-2">
                              <div className="spinner-border spinner-border-sm text-primary me-2" role="status">
                                <span className="visually-hidden">Loading...</span>
                              </div>
                              Searching for "{storevalue}"...
                            </div>
                          )}

                          {/* Success state - SHOW RESULTS (Works for first and subsequent searches) */}
                          {!isSearching && searchStatus === "success" && search_result.length > 0 && (
                            <>
                              {/* <div className="dropdown-item text-muted small border-bottom d-flex justify-content-between align-items-center">
                                <span>Found {search_result.length} products</span>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-outline-primary"
                                  onClick={navigateToSearchPage}
                                >
                                  View All Results
                                </button>
                              </div> */}
                              {search_result.slice(0, 8).map((item, index) => (
                                <button
                                  key={`${item.product_id}_${index}`}
                                  type="button"
                                  className="dropdown-item text-start"
                                  onClick={() => getValue(item.product_name)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <div className="d-flex align-items-center">
                                    <div className="flex-shrink-0 me-2">
                                      <img
                                        src={`${process.env.REACT_APP_API}uploads/${item.product_image}`}
                                        alt={item.product_name}
                                        width="30"
                                        height="30"
                                        className="rounded"
                                        onError={(e) => {
                                          e.target.onerror = null;
                                          e.target.src = "/assets/images/placeholder.jpg";
                                        }}
                                      />
                                    </div>
                                    <div className="flex-grow-1">
                                      <div className="fw-medium">{item.product_name}</div>
                                      <small className="text-success">
                                        ₹{item.price} {item.mrp && <s className="text-muted ms-1">₹{item.mrp}</s>}
                                      </small>
                                    </div>
                                  </div>
                                </button>
                              ))}
                            </>
                          )}

                          {/* Show selected suggestion */}
                          {selectedSuggestion && (
                            <div className="dropdown-item bg-light border-top">
                              <div className="d-flex justify-content-between align-items-center">
                                <small className="text-muted">
                                  Selected: <strong>{selectedSuggestion}</strong>
                                </small>
                                <button
                                  type="button"
                                  className="btn btn-sm btn-primary"
                                  onClick={navigateToSearchPage}
                                >
                                  Go to Search Page
                                </button>
                              </div>
                            </div>
                          )}

                          {/* No results */}
                          {!isSearching && searchStatus === "no_results" && storevalue.trim().length >= 2 && (
                            <div className="dropdown-item text-center py-3 text-muted">
                              <i className="las la-search fs-4 mb-2 d-block"></i>
                              <div>No products found for "{storevalue}"</div>
                              <small>Try different keywords</small>
                            </div>
                          )}

                          {/* Typing state */}
                          {!isSearching && searchStatus === "typing" && storevalue.trim().length >= 2 && (
                            <div className="dropdown-item text-center py-2 text-muted">
                              Keep typing... (600ms delay)
                            </div>
                          )}
                        </div>
                      )}
                    </div>
                  </form>
                </div>
              </div>
            </div>
            <div className="col-6 col-sm-8 col-lg-5 col-xl-4">
              <ul className="quick-links">
                <li className="quick-link-item d-none d-md-inline-flex">
                  <span className="quick-link-icon flex-shrink-0">
                    <a href="#" className="quick-link">
                      <i
                        style={{ marginTop: "8px" }}
                        className="las la-user-circle"
                      ></i>
                    </a>
                  </span>
                  <span className="flex-grow-1">
                    {_id ? (
                      <div>
                        <Link to="/myaccount">
                          {showprofile?.full_name}
                        </Link>
                        <br />
                        <button
                          onClick={singout}
                          style={{
                            background: "none",
                            border: "none",
                            color: "#007bff",
                            padding: "0",
                            cursor: "pointer"
                          }}
                        >
                          Sign out
                        </button>
                      </div>
                    ) : (
                      <div>
                        <Link
                          style={{ marginTop: "15px" }}
                          to="/login"
                          className="my-account"
                        >
                          Register
                        </Link>
                      </div>
                    )}
                  </span>
                </li>

                <li className="quick-link-item d-none d-sm-flex">
                  <Link
                    to={token ? "/Favratewishlist" : "/login"}
                    className="quick-link"
                  >
                    <span className="quick-link-icon flex-shrink-0">
                      <i className="lar la-heart"></i>
                      <span
                        style={{ backgroundColor: "#ffa11d" }}
                        className="badge rounded-pill "
                      >
                        {token ? show_f_cartlist.length : "0"}
                      </span>
                    </span>
                  </Link>
                </li>

                <li
                  className={
                    show_cart_list.length > 0
                      ? token
                        ? "quick-link-item"
                        : ""
                      : ""
                  }
                >
                  <Link
                    style={{ marginTop: "6px" }}
                    to={
                      show_cart_list.length > 0
                        ? token
                          ? "/cardlist"
                          : "/login"
                        : ""
                    }
                    className="quick-link"
                  >
                    <span className="quick-link-icon flex-shrink-0">
                      <i className="las la-shopping-bag"></i>
                      <span
                        style={{ backgroundColor: "#ffa11d" }}
                        className="badge rounded-pill "
                      >
                        {token ? show_cart_list.length : "0"}
                      </span>
                    </span>
                  </Link>
                  <div className="checkout-cart">
                    <ul className="checkout-scroll">
                      {show_cart_list?.map((items, index) => (
                        <li key={index} className="checkout-cart-list">
                          <div className="checkout-img">
                            <img
                              className="product-image"
                              src={`${process.env.REACT_APP_API}uploads/${items.product_image}`}
                              style={{ width: "80px", height: "80px" }}
                              onClick={() => Single_products(items.product_id)}
                              alt="img"
                            />
                          </div>
                          <div className="checkout-block">
                            <span className="product-name">
                              {items.product_name}
                            </span>
                            <span className="product-price">
                              Price : ₹{items.price}
                            </span>
                            <a className="remove-cart" href="#" onClick={(e) => {
                              e.preventDefault();
                              delete_card(items.product_id, items.quantity);
                            }}>
                              <i className="las la-times"></i>
                            </a>
                            <div className="product-size">
                              <s>Mrp: ₹{items.mrp}</s>
                            </div>
                          </div>
                        </li>
                      ))}
                    </ul>

                    <ul className="list-group checkout-sub-total">
                      <li className="list-group-item">
                        <strong>Total</strong>
                        <span className="float-end">
                          ₹
                          {show_cart_list.reduce(
                            (total, item) =>
                              total + Number(item.total_price_ammount || 0),
                            0
                          )}
                        </span>
                      </li>
                    </ul>
                  </div>
                </li>
                <li className="quick-link-item d-lg-none">
                  <button
                    className="toggle-menu"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <i className="las la-bars" style={{ marginTop: "10px" }}></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shearchbar;


